import { render, staticRenderFns } from "./update-allocation.vue?vue&type=template&id=f926c12c&"
import script from "./update-allocation.vue?vue&type=script&lang=js&"
export * from "./update-allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports